import { NextPage } from 'next';
import { isDev } from 'app/general';
import { useEffect } from 'react';
import { logout, updateTokenWithUser } from 'actions/user';
import { auth } from 'firebaseConfig/clientApp';
import { useAppDispatch, useAppSelector } from 'reducers/storeHooks';
import { isUrlAuth, isUrlAvailableForNonUsers, isUrlOnBoarding, onBoardingUrl } from 'helpers/general';
import { usePathname } from 'next/navigation';
import { User as FirebaseUser } from 'firebase/auth';
import { getMyProfile } from 'actions/profile';

interface Props {
  children: JSX.Element;
}

const IsUserLoggedIn: NextPage<Props> = ({ children }) => {
  const dispatch = useAppDispatch();
  const localUser = useAppSelector((state) => state.userReducer.user);
  const pathname = usePathname() || "";
  const { profile: myProfile, loading: myProfileLoading } = useAppSelector((state) => state.profileReducer);
  const loginLoading = useAppSelector((state) => state.userReducer.loginLoading);

  const handleAuthStateChange = async (user: FirebaseUser | null) => {
    if (isDev) {
      console.log("Auth state changed:", { user, localUser, myProfile, myProfileLoading, loginLoading });
    }

    if (user) {
      if (!myProfile && !myProfileLoading) {
        if (isDev) {
          console.log("Fetching user profile...");
        }
        dispatch(getMyProfile(user));
      }

      if (!localUser) {
        if (isDev) {
          console.log("User logged in. Dispatching update token action...");
        }

        user.getIdToken().then(function (idToken) {
          console.log(idToken);
        });

        updateTokenWithUser(user);
      }
    } else {
      if (loginLoading) return;

      if (isUrlAvailableForNonUsers(pathname)) {
        if (isDev) {
          console.log("User not logged in, but URL is available for non-users.");
        }
        return;
      }

      if (isDev) {
        console.log("User logged out. Dispatching logout action...");
      }
      const redirectUrl = isUrlAuth(pathname) || isUrlOnBoarding(pathname) ? undefined : onBoardingUrl;
      dispatch(logout(redirectUrl));
    }
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(handleAuthStateChange);
    return () => unsubscribe();
  }, [myProfile]); // Add myProfile as a dependency for effect

  return children;
};

export default IsUserLoggedIn;
